import { IUserDashboardWidgetItemModel, IUserDashboardLabels, IUnitValue } from 'shared/models';
import { ReactNode } from 'react';
import { formatValueWithUnits } from './../../../../utilities/formatValueWithUnits';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict';

import "./styles.scss"
import classnames from 'classnames';

type PPDWidgetBasePropertiesProps = {
    item: IUserDashboardWidgetItemModel;
    children?: ReactNode;
    labels?: IUserDashboardLabels;
    className?: string
};

const getMainValue= (value?: IUnitValue | IUnitValue[] | null)=> {
    if (!value) return null;
    if (Array.isArray(value)) {
        return value.find(v => v.type === "main") ?? value[0] ?? null;
    }
    return value;
}

const pickHint = (
    value?: IUnitValue | IUnitValue[] | null,
    hint?: string | { main?: string; detailed?: string }
): string | null => {
    if (!hint) return '';

    if (typeof hint === "object") {
        return hint.main ?? '';
    }
    return Array.isArray(value) ? '' : hint;
};

export const PPDWidgetBaseProperties = ({ item, labels, children, className }: PPDWidgetBasePropertiesProps) => {
    const { units } = useDashboardDict();

    const renderValue = (value?: IUnitValue | IUnitValue[] | null) => {
        const main = getMainValue(value);

        if (!main || main.amount == null) {
            return <div className="ppd-widget-base-properties__value">-</div>;
        }

        const unitLabel = main.unit_id ? units?.[main.unit_id]?.long : undefined;

        return (
            <div className="ppd-widget-base-properties__value">
                {formatValueWithUnits(main)}
                {unitLabel && <span className="ppd-widget-base-properties__unit">{unitLabel}</span>}
            </div>
        );
    };

    const renderLabel = (label?: string, hint?: string | { main?: string; detailed?: string }, value?: IUnitValue | IUnitValue[] | null) => {
        if (!label && !hint) return null;

        const finalHint = pickHint(value, hint);

        return (
            <div className="ppd-widget-base-properties__label">
                {label ?? "—"}
                {finalHint && <span className="ppd-widget-base-properties__hint">{finalHint}</span>}
            </div>
        );
    };

    return (
        <div className={classnames('ppd-widget-base-properties', className)}>
            <div className="ppd-widget-base-properties__item">
                {renderLabel(labels?.plan, item?.plan_hint, item?.plan)}
                {renderValue(item?.plan)}
            </div>

            {children}

            <div className="ppd-widget-base-properties__item">
                {renderLabel(labels?.fact, item?.fact_hint, item?.fact)}
                {renderValue(item?.fact)}
            </div>
        </div>
    );
};
